// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"SectionTitle_SectionTitle__334P_","Line":"SectionTitle_Line__9eoSt","SectionTitleDesc":"SectionTitle_SectionTitleDesc__2udjm"};